import React from 'react';
import {
    IconSectionData,
    MediaLogosOrReviewsSection,
    HealthBenefitsSection,
    Statement,
    IconMedia,
} from '../../../types/KontentProps';

import ReviewStar from './ReviewStar.svg';

const renderMediaLogosOrReviews = (
    section: MediaLogosOrReviewsSection,
    styles: any,
    bg: string,
    color: string
) => {
    const style = section.icon_section_style?.value?.[0]?.codename;
    if (!style) return null;

    return (
        <div className={styles.mediaContainer}>
            <hr className={styles.horizontalLine} />
            {/* Title */}
            <p
                className={styles.mediaTitle}
                data-kontent-element-codename="icon_section_title"
            >
                {section?.icon_section_title?.value}
            </p>

            {/* Stars */}
            <div className={styles.stars}>
                {Array.from({ length: 5 }).map((_, idx) => (
                    <img
                        src={ReviewStar}
                        alt="Review star"
                        className={styles.starIcon}
                        key={idx}
                    />
                ))}
            </div>

            {/* Logos only if media_logos */}
            {style === 'media_logos' && (
                <div className={styles.logoGrid}>
                    {section.icon_statements.value.map((item) => {
                        if (!('file' in (item.elements || {}))) return null;

                        const mediaItem = item as IconMedia;

                        return mediaItem.elements.file.value.map(
                            (asset, idx) => {
                                if (!asset?.url) return null;

                                return (
                                    <div className={styles.logoItem} key={idx}>
                                        <img
                                            src={asset.url}
                                            alt={
                                                asset.description ||
                                                'Media logo'
                                            }
                                            className={styles.logoImage}
                                            loading="lazy"
                                        />
                                    </div>
                                );
                            }
                        );
                    })}
                </div>
            )}
        </div>
    );
};

const renderHealthBenefits = (
    section: HealthBenefitsSection,
    styles: any,
    bg: string,
    color: string
) => {
    if (!section.icon_statements.value.length) return null;

    return (
        <div
            className={styles.columnContainer2}
            style={{
                backgroundColor: bg || 'inherit',
                color: color || 'inherit',
            }}
        >
            <hr className={styles.horizontalLine} />
            <div className={styles.iconGrid}>
                {section.icon_statements.value.map((item) => {
                    const statement = item as Statement;
                    const title = statement.elements.display_title?.value;
                    const iconUrl =
                        statement.elements.icon?.value?.[0]?.elements
                            ?.icon_svg_file?.value?.[0]?.url;

                    return (
                        <div className={styles.iconItem} key={title}>
                            {iconUrl && (
                                <img
                                    src={iconUrl}
                                    alt={title || 'Icon'}
                                    className={styles.iconImage}
                                    loading="lazy"
                                />
                            )}
                            {title && (
                                <p
                                    className={styles.iconTitle}
                                    data-kontent-element-codename="display_title"
                                >
                                    {title}
                                </p>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

const isMediaLogosOrReviewsSection = (
    section: IconSectionData
): section is MediaLogosOrReviewsSection => {
    const codename = section.icon_section_style?.value?.[0]?.codename;
    return codename === 'media_logos' || codename === 'reviews';
};

const isHealthBenefitsSection = (
    section: IconSectionData
): section is HealthBenefitsSection => {
    const codename = section.icon_section_style?.value?.[0]?.codename;
    return codename === 'health_benefits';
};

export const renderIconSection = (
    section: IconSectionData,
    healthSectionstyles: any,
    mediaLogoSectionStyles: any,
    bg: string,
    color: string
) => {
    const style = section.icon_section_style?.value?.[0]?.codename;

    if (!style || style === 'hide') {
        return null;
    }

    if (isMediaLogosOrReviewsSection(section)) {
        return renderMediaLogosOrReviews(
            section,
            mediaLogoSectionStyles,
            bg,
            color
        );
    }

    if (isHealthBenefitsSection(section)) {
        return renderHealthBenefits(section, healthSectionstyles, bg, color);
    }

    return null;
};
